import { SUPPORTED_LANGUAGES } from "../constants/config";

const SESSION_LANG_KEY = "selectedLanguage";

/**
 * Resuelve el idioma inicial de la app con la siguiente prioridad:
 * 1. Idioma guardado en sessionStorage (seleccionado por el usuario)
 * 2. Query param "lang" de la URL
 * 3. Idioma del navegador/sistema
 * 4. Fallback: "en"
 *
 * Si el idioma detectado no está entre los soportados, retorna "en".
 */
export const resolveInitialLanguage = () => {
  const FALLBACK = "en";

  // 1. SessionStorage (selección previa del usuario)
  try {
    const savedLang = sessionStorage.getItem(SESSION_LANG_KEY)?.toLowerCase();
    if (savedLang && SUPPORTED_LANGUAGES.includes(savedLang)) {
      return savedLang;
    }
  } catch {
    // sessionStorage no disponible, continuar
  }

  // 2. Query param
  const queryParams = new URLSearchParams(window.location.search);
  const langParam = queryParams.get("lang")?.toLowerCase();

  if (langParam && SUPPORTED_LANGUAGES.includes(langParam)) {
    return langParam;
  }

  // 3. Idioma del sistema/navegador
  const browserLang = (navigator.language || navigator.userLanguage || "")
    .split("-")[0]
    .toLowerCase();

  if (browserLang && SUPPORTED_LANGUAGES.includes(browserLang)) {
    return browserLang;
  }

  // 4. Fallback
  return FALLBACK;
};

/**
 * Guarda el idioma seleccionado en sessionStorage.
 */
export const saveLanguageToSession = (lang) => {
  try {
    sessionStorage.setItem(SESSION_LANG_KEY, lang);
  } catch {
    // sessionStorage no disponible, ignorar
  }
};
